import React, { useState } from 'react';
import Checkbox from '../CheckboxField/CheckboxField';
import InputContainer from '../InputContainer/InputContainer';
import Label from '../Label/Label';
import { BaseInputProps } from '../shared-types';
import { getGetIdFn } from '../utils';

export type MultiselectGroupOption = {
  label: string;
  value: string;
};

export type Props = Omit<BaseInputProps, 'onChange'> & {
  onChange: (value: MultiselectGroupOption[]) => void;
  options: MultiselectGroupOption[];
};

const getLabelId = getGetIdFn('Label');

const MultiselectGroup: React.FC<Props> = ({
  onChange,
  label,
  options,
  styleInputContainer,
}) => {
  const labelId = getLabelId();
  const [selected, setSelected] = useState<MultiselectGroupOption[]>([]);

  return (
    <InputContainer aria-labelledby={labelId} style={styleInputContainer}>
      <Label label={label} id={labelId} />
      <div data-testid="MultiselectGroup" className="MultiselectGroup">
        {options.map((option) => (
          <Checkbox
            key={option.value}
            label={option.label}
            checked={selected.findIndex((v) => v.value === option.value) >= 0}
            styleInputContainer={{ display: 'flex' }}
            onChange={(checked) => {
              const index = selected.findIndex((v) => v.value === option.value);
              let updatedSelection = selected;
              if (index >= 0 && !checked) {
                updatedSelection = [
                  ...selected.slice(0, index),
                  ...selected.slice(index + 1),
                ];
              } else if (index < 0 && checked) {
                updatedSelection = [
                  ...selected,
                  { value: option.value, label: option.label },
                ];
              }
              setSelected(updatedSelection);
              onChange(updatedSelection);
            }}
          />
        ))}
      </div>
    </InputContainer>
  );
};

export default MultiselectGroup;
